import { gql } from '@apollo/client';

const SPORTS_FISHING_RESULTS = gql`
  query sportFishingResults($filter: ListSportFishingResultInput) {
    sportFishingResults(filter: $filter)
  }
`;

export default SPORTS_FISHING_RESULTS;
